import styled from "styled-components";

export const Image = styled.img`
    filter: grayscale(100%);
    border-radius: 50%;
    min-width: 3rem;
    min-height: 3rem;
    object-fit: cover;
    cursor: ${(props) => (props.clickable ? "pointer" : "initial")};
`;
